import type { Link } from '@wix/public-schemas'
import { SAME_TAB_TARGET } from './constants'
import type { TpaPageLinkData } from './linksDataTypes'
import { addRelToLinkProps } from './linkUtils'

export type TpaPageLinkExtraData = {
	externalBaseUrl: string
}

export const handleTpaPageLink = (linkData: TpaPageLinkData, extraData: TpaPageLinkExtraData) => {
	const { externalBaseUrl } = extraData
	const { path, rel } = linkData
	const pathWithoutSlash = path.replace(/^\//, '')

	const baseLinkProps = {
		href: `${externalBaseUrl}${pathWithoutSlash ? `/${pathWithoutSlash}` : ''}`,
		target: SAME_TAB_TARGET,
	} as Link

	return addRelToLinkProps(baseLinkProps, rel)
}
